export default __webpack_public_path__ + "static/media/1181.fd1b81b5.png";